import { useEffect, useState } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import Logo from "../assets/med-images/logo.svg";
import LogZaloker from "../assets/med-images/logo-zz.png";

// const navigation = [
//   { name: "Juttis", href: "/" },
//   { name: "Sandals", href: "/" },
//   { name: "Kolhapuris", href: "/shop" },
//   { name: "PNP X Anushree Reddy", href: "/deals" },
//   { name: "Wedding Shops", href: "/" },
//   { name: "KURTA SETS", href: "/" },
//   { name: "FESTIVE BAGS", href: "/" },
//   { name: "Celebrity", href: "/" },
// ];

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);

  return (
    <div className="fixed top-0 w-full z-20 bg-white shadow-md px-5 py-5">
      <div className="px-6 lg:px-8">
        <nav className="flex items-center justify-between" aria-label="Global">
          <div className="flex lg:flex-1">
            <Link to="/" className="-m-1.5 p-1.5">
              <img className="h-8" src={Logo} alt="logo" />
            </Link>
          </div>
          {/* <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div> */}
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
            <a href="https://www.zaloker-zaloker.si" _target="blank">
              <img src={LogZaloker} className="h-8" />
            </a>
          </div>
        </nav>

      </div>
    </div>
  );
}
export default Header;
